import { render } from "./MemberUsersManager.vue?vue&type=template&id=3bd9bf8b"
import script from "./MemberUsersManager.vue?vue&type=script&lang=js"
export * from "./MemberUsersManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__